/**
 * KAN-670: рейтинг продавца звёздами 1..5. Без onChange: только показ (компактно, с title);
 * с onChange: клик по звезде ставит оценку, повторный клик по текущей снимает её.
 */
import { Star } from 'lucide-react';
import { SELLER_RATING_MAX, ratingSetTitle, ratingTitle } from '@/lib/sellerLink';

interface Props {
  value: number | null | undefined;
  onChange?: (value: number | null) => void;
  disabled?: boolean;
  size?: 'sm' | 'md';
  testId?: string;
}

export function RatingStars({
  value,
  onChange,
  disabled,
  size = 'sm',
  testId = 'rating-stars',
}: Props): JSX.Element {
  const current = value ?? 0;
  const iconClass = size === 'md' ? 'h-5 w-5' : 'h-3.5 w-3.5';
  const stars = Array.from({ length: SELLER_RATING_MAX }, (_, i) => i + 1);
  return (
    <span
      className="inline-flex items-center gap-0.5 align-middle"
      data-testid={testId}
      data-rating={value ?? ''}
      title={ratingTitle(value)}
      role={onChange ? 'radiogroup' : 'img'}
      aria-label={ratingTitle(value)}
    >
      {stars.map((n) => {
        const filled = n <= current;
        const icon = (
          <Star
            className={`${iconClass} ${filled ? 'fill-amber-400 text-amber-400' : 'text-gray-300'}`}
          />
        );
        if (!onChange) {
          return <span key={n}>{icon}</span>;
        }
        return (
          <button
            key={n}
            type="button"
            role="radio"
            aria-checked={n === current}
            aria-label={ratingSetTitle(n)}
            title={ratingSetTitle(n)}
            data-testid={`${testId}-${n}`}
            disabled={disabled}
            className="rounded p-0.5 hover:bg-gray-100 disabled:cursor-not-allowed disabled:opacity-50"
            onClick={() => onChange(n === current ? null : n)}
          >
            {icon}
          </button>
        );
      })}
    </span>
  );
}
